<template>
  <div class="animated fadeIn">
    <ValidationObserver ref="observer" v-slot="{ invalid, validate }">
      <b-row>
        <b-col md="12">
          <component-header
            title="Create Access Rules"
            :hasSearch="false"
            :hasReload="false"
            :hasCreate="false"
            :hasback="true"
            @back-press="$router.push({ path: '/setup/accessrule' })"
          />
        </b-col>
        <b-col md="12">
          <b-card>
            <ValidationObserver v-slot="{ invalid }">
              <form>
                <b-row class="mt-4">
                  <b-col md="6">
                    <label for="planName">Name</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="planName"
                    >
                      <b-form-input
                        id="planName"
                        inputType="text"
                        placeholder="Enter plan name"
                        v-model="inputObject.name"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col md="6">
                    <label for="keys">keys</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="keys"
                    >
                      <multiselect
                        v-model="inputObject.keys"
                        tag-placeholder="Add this as new keys"
                        placeholder="Select keys List"
                        label="name"
                        track-by="keys"
                        :options="permissions"
                        :multiple="true"
                        :taggable="false"
                        :open-direction="'bottom'"
                      ></multiselect>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary mt-4"
                    :disabled="invalid"
                    classic="btn-primary"
                    text="Save"
                    @click.prevent="handleSubmit"
                  >
                    Save
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </b-card>
        </b-col>
      </b-row>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import ebSelect from "@/components/FormElements/Select.vue";
import { listPermissions } from "@/services/auth";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "createfaq",
  components: {
    ebButton,
    ValidationProvider,
    ValidationObserver,
    ebSelect,
    ComponentHeader,
  },
  data: () => {
    return {
      show: true,
      inputObject: {
        name: "",
        keys: "",
        keys: "",
      },
      permissions: [],
      permissions: [],
    };
  },
  methods: {
    async handleSubmit() {
      this.$refs.observer.validate().then((isValid) => {
        if (!isValid) {
          this.$swal({
            title: "Warning",
            text: "Please fill in the required fields",
            type: "warning",
          });
          return;
        }
      });
      let x = [];
      this.inputObject.keys.forEach((obj) => {
        x.push(obj.keys);
      });
      let data = {};
      data = {
        name: this.inputObject.name,
        keys: x,
      };
      await this.$store
        .dispatch("accessrule/createAccessrule", data)
        .then((result) => {
          this.$swal({
            title: "Success",
            text: "Access Rule added successfully!!",
            type: "success",
          });
          this.$router.push({ path: "/setup/accessrule" });
        });
    },
  },
  async mounted() {
    try {
      const result = await listPermissions();
      this.permissions = result.response.map((d) => {
        return {
          name: d.name,
          keys: d.name,
          keys: d.name,
        };
      });
    } catch (e) {
      this.$toasted.error(e.message);
    }
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.myDIV:hover + .hide {
  display: block;
  position: absolute;
}
.hide {
  display: none;
  font-size: 11px;
}
</style>
